var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsCard',{attrs:{"newsList":_vm.newsList,"totalElements":_vm.totalElements,"isLoading":_vm.isLoading},on:{"showMoreNews":_vm.fetchNextNews}})
}
var staticRenderFns = []

export { render, staticRenderFns }